import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { Logo } from "@insite/content-library/Widgets/Basic/Logo";
import { LogoImage } from "@insite/content-library/Widgets/Common/LanguageMenu";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Img from "@insite/mobius/Img";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface NewBrandLogo {
    container: InjectableCss;
    brandText: InjectableCss;
}

export const NewBrandLogoStyles: NewBrandLogo = {
    container: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    brandText:{
        css: css`
        alignContent: 'center'
        `
    }
};

const NewBrandLogo: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...NewBrandLogoStyles.container}>
        <StyledWrapper style={{ alignContent: 'center',justifyContent: 'center', paddingRight: '12%', fontSize: '12px'}}>Brands:</StyledWrapper>
        <StyledWrapper style={{ alignContent: 'center', paddingRight: '12%',paddingTop: '8px', }}>
            <Zone contentId={id} zoneName="Logo1" />
        </StyledWrapper>
        <StyledWrapper style={{ alignContent: 'center',paddingTop: '5px', }}>
            <Zone contentId={id} zoneName="Logo2" />
        </StyledWrapper>
    </StyledWrapper>
);

const widgetModule: WidgetModule = {
    component: NewBrandLogo,
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        displayName: "New Brand Logo",
    },
};

export default widgetModule;
